import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import secureLocalStorage from "react-secure-storage";

const EditSalesOrder = () => {
    const userID = secureLocalStorage.getItem("userID");
    const navigate = useNavigate();
    const location = useLocation();

    // dropdown
    const [productData, setProductData] = useState([]);
    const [clientData, setClientData] = useState([]);

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useFetch: fetchClientProductAssociation } = useAPIQuery({
        key: "client-product",
        endpoint: "/api/client-item-association/",
    });

    const { data: clientDropdown, isLoading: isClientLoading } =
        fetchClientProductAssociation({
            abortOnNewRequest: true,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 3,
            retry: 3,
            keepPlaceholder: true,
            refetchOnReconnect: true,
        });

    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
        watch,
        setValue,
    } = useForm();

    const quantity = watch("quantity");

    const { useUpdate } = useAPIQuery({
        key: "sales_order",
        endpoint: "/api/sales-order/",
    });

    const handleUpdateSalesOrder = (data) => {
        Swal.fire({
            title: "Sales Order Updated!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        });
    };

    const handleErrorSalesOrder = (data) => {
        Swal.fire({
            title: "Error Updating Sales Order",
            text: data?.response?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useUpdate({
        onSuccess: handleUpdateSalesOrder,
        onError: handleErrorSalesOrder,
        retry: 2,
    });

    const [selectedProduct, setSelectedProduct] = useState(null);

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        const formattedDate = data.target_date
            ? format(new Date(data.target_date), "yyyy-MM-dd")
            : null;
        var sale_order = {
            product_id: data.product.value,
            client_id: clientData?.client?.id,
            target_date: formattedDate,
            dispatch_location: data.dispatch_location,
            quantity: data.actual_quantity,
            activity_status: 2, // Sales order as draft
            updated_by: userID,
        };

        if (!sale_order.client_id) {
            Swal.fire({
                title: "Error",
                text: "Client is not associated with the item",
                icon: "error",
            });
            return;
        }

        if (!selectedProduct.bom_code) {
            Swal.fire({
                title: "Error",
                text: "BOM is not created for this item",
                icon: "error",
            });
            return;
        }

        mutate({
            id: location.state.editpost.id,
            data: sale_order,
        });
    };

    useEffect(() => {
        if (quantity && selectedProduct) {
            const required_quantity = selectedProduct?.required_quantity || 1;

            console.log(required_quantity);
            console.log(selectedProduct);
            const total_required = Math.ceil(
                Number(quantity) * required_quantity
            );
            const total_quantity = Math.round(
                total_required / required_quantity
            );
            setValue("actual_quantity", total_quantity);
        }
    }, [quantity, selectedProduct]);

    // Pre Population of Particular Product details
    useEffect(() => {
        const editSalesOrder = location.state.editpost;
        // defaultValues is a react form hook.
        if (editSalesOrder) {
            var defaultValues = {};
            defaultValues.target_date = editSalesOrder.target_date;
            defaultValues.quantity = editSalesOrder.quantity;

            const product_data = productData.find((api) => {
                return api.id === editSalesOrder.product?.id;
            });
            const getProduct = {
                value: product_data?.id,
                label: product_data?.item_name,
                item_code: product_data?.item_code,
                bom_code: product_data?.bom_code,
                required_quantity: product_data?.required_quantity,
            };
            defaultValues.product = getProduct;
            setSelectedProduct(getProduct);

            const getClient = {
                value: editSalesOrder.client?.id,
                label:
                    editSalesOrder.client?.user?.first_name +
                    editSalesOrder.client?.user?.last_name,
            };
            defaultValues.client = getClient;

            defaultValues.dispatch_location = editSalesOrder.dispatch_location;

            reset(defaultValues);
        }
    }, [productData]);

    useEffect(() => {
        if (data) {
            setProductData(data.item.filter((api) => api.category === "FG"));
        }
    }, [data]);

    useEffect(() => {
        if (clientDropdown) {
            setClientData(
                clientDropdown.results.data.find((api) => {
                    return api.item?.id === selectedProduct?.value;
                })
            );
        }
    }, [clientDropdown, selectedProduct]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> Edit Sales Order </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Product Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={productData.map(
                                                    (api) => {
                                                        return {
                                                            label: api.item_name,
                                                            value: api.id,
                                                            item_code:
                                                                api.item_code,
                                                            bom_code:
                                                                api.bom_code,
                                                            required_quantity:
                                                                api.required_quantity,
                                                        };
                                                    }
                                                )}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-product"
                                                onChange={(e) => {
                                                    setSelectedProduct(e);
                                                    field.onChange(e);
                                                }}
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="product"
                                        control={control}
                                    />
                                    {errors.product && (
                                        <span className="fs-8 text-danger">
                                            Product Name is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        {" "}
                                        Product ID{" "}
                                    </label>
                                    <div className="text-dark fw-bold fs-6">
                                        {selectedProduct
                                            ? selectedProduct.item_code
                                            : "Please select Product first"}
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        {" "}
                                        BOM ID{" "}
                                    </label>
                                    <div className="text-dark fw-bold fs-6">
                                        {selectedProduct
                                            ? selectedProduct.bom_code
                                            : "Please select Product first"}
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Client Name
                                    </label>
                                    <div className="text-dark fw-bold fs-6">
                                        {clientData
                                            ? clientData.client?.user
                                                  ?.first_name +
                                              " " +
                                              clientData.client?.user?.last_name
                                            : "Please select Product first"}
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Quantity
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <div className="row">
                                        <div className="col-5">
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter no of quantity"
                                                id="number-forms-quantity"
                                                {...register("quantity")}
                                                onWheel={(e) => e.target.blur()}
                                            />
                                        </div>
                                        <div className="col-1 align-self-center text-center">
                                            <em className="icon ni ni-arrow-long-right"></em>
                                        </div>
                                        <div className="col-5">
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Calculted Quantity"
                                                id="number-forms-quantity"
                                                {...register(
                                                    "actual_quantity",
                                                    {
                                                        required:
                                                            "Quantity is required",
                                                        validate: {
                                                            positive: (value) =>
                                                                value > 0 ||
                                                                "Only positive numbers are allowed",
                                                        },
                                                    }
                                                )}
                                                onWheel={(e) => e.target.blur()}
                                                readOnly
                                            />
                                            {errors.actual_quantity && (
                                                <span className="fs-8 text-danger">
                                                    {
                                                        errors.actual_quantity
                                                            .message
                                                    }
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Target Date
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <div>
                                        <div className="form-control-wrap">
                                            <div className="input-group">
                                                <Controller
                                                    render={({ field }) => (
                                                        <DatePicker
                                                            className="form-control"
                                                            placeholderText="Select Target date"
                                                            selected={
                                                                field.value
                                                            }
                                                            onChange={(date) =>
                                                                field.onChange(
                                                                    date
                                                                )
                                                            }
                                                            minDate={new Date()} // Can't select past dates
                                                            maxDate={
                                                                new Date(
                                                                    "2030-12-31"
                                                                )
                                                            } // Set max date
                                                        />
                                                    )}
                                                    defaultValue=""
                                                    rules={{ required: true }}
                                                    name="target_date"
                                                    control={control}
                                                />
                                                <div className="input-group-append">
                                                    <span
                                                        className="input-group-text"
                                                        id="basic-addon2"
                                                    >
                                                        <em class="icon ni ni-calendar-check-fill"></em>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {errors.target_date && (
                                        <span className="fs-8 text-danger">
                                            Target Date is required
                                        </span>
                                    )}
                                    {/* <input
                                    type="date"
                                    className="form-control"
                                    id="email-forms-target_date"
                                    {...register("target_date", {
                                      required: true,
                                    })}
                                  /> */}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Dispatch Location
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Dispatch location"
                                        id="text-forms-dispatch_location"
                                        {...register("dispatch_location", {
                                            required: true,
                                        })}
                                    />
                                    {errors.dispatch_location && (
                                        <span className="fs-8 text-danger">
                                            Dispatch Location is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-sales-order-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-update-sales-order"
                                            >
                                                Update
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditSalesOrder;
